import * as React from 'react'

import { useIsoLayoutEffect } from '../../../hooks/use-iso-layout-effect'

export const useTextAreaAutoGrow = (
  deps: React.DependencyList,
  opts?: { minHeight?: number }
) => {
  const textareaRef = React.useRef<HTMLTextAreaElement>(null)

  const depsMemo = React.useMemo(() => {
    return [opts?.minHeight, ...(deps ?? [])]
  }, [deps, opts?.minHeight])

  useIsoLayoutEffect(() => {
    function autoGrowElHeight(element: HTMLTextAreaElement) {
      element.style.height = '1px'
      element.style.height =
        Math.max(opts?.minHeight ?? 0, element.scrollHeight) + 'px'
    }

    let el = textareaRef.current
    let interval = 0
    if (!el) {
      let i = 0
      interval = window.setInterval(() => {
        el = textareaRef.current
        if (i > 16) {
          clearInterval(interval)
          return
        }
        if (el) {
          clearInterval(interval)
          return
        }
        i++
      }, 1)
    }

    if (!el) return

    autoGrowElHeight(el)

    const handleResize = () => {
      if (!el) return
      autoGrowElHeight(el)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      window.clearInterval(interval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, depsMemo)

  return textareaRef
}
